/**
 * Shared Product wrapper — GI Presenze
 *
 * Wrapper attorno al SuiteLauncher Foundation/Core. Il componente CORE e' generico
 * (nessun riferimento a GI Presenze); questo wrapper inietta il contesto
 * specifico del Product Pack corrente:
 * - `currentModuleKey = "presenze"` (per il badge "Sei già qui" e il footer versione)
 * - `modules` derivati da `defaultSuiteModules()` + URL risolti localmente
 *   tramite `getSuiteApplicationUrls()` (utility di ambiente Shared Product).
 *
 * Import legacy `@/lib/suiteApplications` (K12): sara' assimilato nello STEP D4
 * (piano P2.0) e questo wrapper diventera' banale. La rimozione della barrel
 * legacy avverra' nella fase P2.0-Z Barrel Cleanup.
 */
import React, { useMemo } from "react";
import { SuiteLauncher, defaultSuiteModules, getSuiteApplicationUrls } from "@/foundation/shell";

const CURRENT_MODULE_KEY = "presenze";

export default function SuiteLauncherPresenze(props) {
  const modules = useMemo(
    () => defaultSuiteModules(getSuiteApplicationUrls()),
    []
  );
  return (
    <SuiteLauncher
      {...props}
      currentModuleKey={CURRENT_MODULE_KEY}
      modules={modules}
    />
  );
}
